import { ColDef } from "ag-grid-community";
import { ColumnTypeEnum, createGroupColumn } from "../../../../components";

export const errorsColumnDefinitions: ColDef[] = [
  createGroupColumn("Timestamp", "updatedAt", ColumnTypeEnum.Text),
  createGroupColumn("Instrument", "symbolAndExchange", ColumnTypeEnum.Text),
  createGroupColumn("Provider", "provider", ColumnTypeEnum.Text),
  createGroupColumn("Error", "error", ColumnTypeEnum.Text),
];
